import { render, staticRenderFns } from "./editTrigger.vue?vue&type=template&id=97882d42&lang=pug"
import script from "./editTrigger.vue?vue&type=script&lang=js"
export * from "./editTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports